import React from 'react'
import { styled, ThemeProvider } from 'baseui'
import { lightTheme } from '@/customTheme'
import { Z_INDEX } from '@/constants/z-index'
import { HIDE_SCROLLBAR_STYLE, MOBILE_MEDIA_QUERY } from '@/constants/responsive'

const Root = styled('div', (props: { $boxShadow?: boolean; $stackOnMobile?: boolean }) => ({
  minHeight: '64px',
  background: lightTheme.colors.white,
  display: 'flex',
  padding: '0 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  zIndex: Z_INDEX.NAVBAR,
  boxShadow: props.$boxShadow ? '0px 0px 6px 0px rgba(0, 0, 0, 0.08)' : undefined,
  ...(props.$stackOnMobile ? {
    [MOBILE_MEDIA_QUERY]: {
      minHeight: 'auto',
      padding: '8px 12px',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '8px',
    },
  } : {}),
}))

const LeftSection = styled('div', (props: { $stackOnMobile?: boolean }) => ({
  display: 'flex',
  flex: '1 1 0px',
  alignItems: 'center',
  gap: '16px',
  minWidth: 0,
  ...(props.$stackOnMobile ? {
    [MOBILE_MEDIA_QUERY]: {
      flex: '0 0 auto',
      width: '100%',
      gap: '8px',
    },
  } : {}),
}))

const RightSection = styled('div', (props: { $stackOnMobile?: boolean }) => ({
  display: 'flex',
  flex: '1 1 0px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '8px',
  minWidth: 0,
  ...(props.$stackOnMobile ? {
    [MOBILE_MEDIA_QUERY]: {
      flex: '0 0 auto',
      width: '100%',
      justifyContent: 'flex-start',
      overflowX: 'auto',
      overflowY: 'hidden',
      paddingBottom: '2px',
      ...HIDE_SCROLLBAR_STYLE,
    },
  } : {}),
}))

type NavbarShellProps = {
  left: React.ReactNode
  right: React.ReactNode
  /** When true, renders a subtle box-shadow below the bar. */
  boxShadow?: boolean
  /** Stacks the left and right sections into scroll-safe rows on narrow screens. */
  stackOnMobile?: boolean
  style?: React.CSSProperties
}

export function NavbarShell({ left, right, boxShadow, stackOnMobile, style }: NavbarShellProps) {
  return (
    <ThemeProvider theme={lightTheme}>
      <Root $boxShadow={boxShadow} $stackOnMobile={stackOnMobile} style={style}>
        <LeftSection $stackOnMobile={stackOnMobile}>{left}</LeftSection>
        <RightSection $stackOnMobile={stackOnMobile}>{right}</RightSection>
      </Root>
    </ThemeProvider>
  )
}